import { render, staticRenderFns } from "./AcoesAnular.vue?vue&type=template&id=2b45edcd&scoped=true"
import script from "./AcoesAnular.vue?vue&type=script&lang=js"
export * from "./AcoesAnular.vue?vue&type=script&lang=js"
import style0 from "./AcoesAnular.vue?vue&type=style&index=0&id=2b45edcd&prod&scoped=true&lang=stylus"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b45edcd",
  null
  
)

export default component.exports